<template>
    <div id="network-lists">
        <status-message></status-message>
        <div class="lists-header td-flex">
            <h1 class="td-h2">Network Lists</h1>
            <button class="td-btn primary slim icon-left" title="View" @click.prevent="openAddModal">
                <icon type="solid" name="faPlus" aria-hidden="true"></icon> Add New
            </button>
        </div>
        <div class="mb-4 td-banner info">
            <icon type="solid" name="faInfoCircle" aria-hidden="true"></icon>
            <p class="ma-0 mb-1">This page includes vendors participating in programs such as NAPA, TruckPro, or similar networks.</p>
            <p class="ma-0">We record each vendor’s Network ID to verify eligibility for free or deeply discounted paid listings as part of these programs.</p>
        </div>
            <div class="network-lists td-table-container mt-0" v-if="networkLists && networkLists.length > 0">
                <table cellspacing="0" cellpadding="0" class="td-table">
                    <thead>
                        <tr class="table-header">
                            <th>Name</th>
                            <th>Network ID</th>
                            <th class="show-mobile"></th>
                            <th class="td-text-right"></th>
                        </tr>
                    </thead>
                    <tbody v-if="!isLoading && networkLists.length > 0" class="rows-container">
                        <tr class="table-row main-row" v-for="(networkList, index) in networkLists" :key="networkList.id">
                            <td class="name">
                                <h2 class="td-h5 mt-0">
                                    {{ getNetworkName(networkList.code) }}
                                </h2>
                            </td>
                            <td class="id">
                                {{ networkList.networkId }}
                            </td>
                            <td class="show-mobile"></td>
                           
                            <td class="table-actions">
                                <div class="td-flex">
                                    <button class="td-btn secondary-outlined slim icon-left" title="View" @click.prevent="openEditModal(networkList)">
                                        <icon type="solid" name="faPen" aria-hidden="true"></icon> Edit
                                    </button>
                                    <button class="td-btn danger slim icon-left" title="View" @click.prevent="openDeleteModal(networkList)">
                                        <icon type="solid" name="faTrash" aria-hidden="true"></icon> Delete
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-if="isLoading">
                        <tr><th colspan="5"><div class="loading"><icon name="faSpinner" type="solid" spin></icon></div></th></tr>
                    </tbody>
                </table>
            </div>
    </div>
    <div v-if="networkLists && networkLists.length < 1 && !isLoading" class="td-banner warning no-icon mt-2">
        <p>No network lists found.</p>
    </div>
    <modal @close="closeDeleteModal" style="max-width:800px;height:auto" v-if="showDeleteModal" class="delete-modal">
        <template #header>
            <h4 class="td-h4">Delete Network List</h4>
        </template>
        <p class="my-2"> Are you sure you want to remove this network list?</p>
        <template #footer>
            <div class="actions">
                <button class="td-btn btn secondary-outlined" title="Cancel Delete" @click="closeDeleteModal">Cancel</button>
                <button class="danger td-btn" title="Delete Network List" @click="confirmDelete">Delete</button>
            </div>
        </template>
    </modal>
    <modal @close="closeEditModal" style="max-width:800px;height:auto" v-if="showEditModal || showAddModal" class="list-modal">
        <template #header>
            <h4 class="td-h4"><span v-if="showEditModal">Edit</span><span v-else>Add</span> Network List</h4>
        </template>
        <div class="my-2">
            <label class="td-label" for="list">Name:</label>
            <select name="list" v-model="editedList.code" :disabled="showEditModal" @change="networkListValidator.validate('code')">
                <option disabled value="">Select Network</option>
                <option v-for="list in selectableLists" :value="list.code" :key="list.id">{{list.name}}</option>

            </select>
            <error v-if="networkListValidator.errors['code']" :error="networkListValidator.errors['code']"></error>
        </div>
         <div class="my-2">
             <label class="td-label">Network ID:</label>
             <input :class="[{'error': networkListValidator.errors['networkId']}, 'td-input']"
                    v-model="editedList.networkId" type="text" placeholder="Network ID" 
                    @input="networkListValidator.validate('networkId')"/>
             <error v-if="networkListValidator.errors['networkId']" :error="networkListValidator.errors['networkId']"></error>
         </div>
        <template #footer>
            <div class="actions">
                <button class="td-btn btn secondary-outlined" title="Cancel Edit Network List" @click="closeEditModal">Cancel</button>
                <button class="secondary td-btn" title="Edit Network List" @click="confirmSave">Save</button>
            </div>
        </template>
    </modal>
</template>

<script>
    import script from './NetworkLists';
    export default script;</script>

<style lang="less">
    @import "./NetworkLists.less";
</style>